import { observer } from 'mobx-react-lite'
import { DeleteDocumentDialog } from './index'
import { type DeleteDocumentDialogViewModel } from './DeleteDocumentDialogViewModel'

export interface DeleteDocumentDialogContainerProps {
  vm: DeleteDocumentDialogViewModel
}

/**
 * Container for the DeleteDocumentDialog that wires up the view model.
 */
export const DeleteDocumentDialogContainer = observer(
  function DeleteDocumentDialogContainer({
    vm,
  }: DeleteDocumentDialogContainerProps) {
    const testId = 'delete-document-dialog'

    return (
      <DeleteDocumentDialog
        isOpen={vm.modal.showing}
        onClose={vm.cancel}
        isDismissable={!vm.delete.pending}
        documentTitle={vm.document?.title ?? ''}
        isDeletePending={vm.delete.pending}
        onConfirmDeletePress={vm.delete}
        testId={testId}
        deleteButtonTestId={`${testId}-delete-button`}
        cancelButtonTestId={`${testId}-cancel-button`}
      />
    )
  },
)
